var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74794 14.0663C7.55594 14.0663 7.37993 14.0023 7.23593 13.8583L4.05195 10.6743C3.76395 10.3863 3.76395 9.93828 4.05195 9.65028C4.33995 9.36228 4.78793 9.36228 5.07593 9.65028L7.76394 12.3223L14.1479 5.95428C14.4359 5.66628 14.8839 5.66628 15.1719 5.95428C15.4599 6.24228 15.4599 6.69028 15.1719 6.97828L8.27593 13.8583C8.11593 14.0023 7.93994 14.0663 7.74794 14.0663Z",
    fill: "#484848",
    stroke: "#484848",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b6c1242433216a31c49fcfd420b28bfe.svg";
export { ForwardRef as ReactComponent };